var _filter, _rect, _rect2, _text, _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgA2AExample(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "researchGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#8b5cf6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#7c3aed"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "writerGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#ec4899"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#db2777"
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "a2aExShadow"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 2,
    dy: 3,
    stdDeviation: 4,
    floodOpacity: 0.4
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 350,
    fill: "#0f172a"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 760,
    height: 310,
    rx: 15,
    fill: "#1e293b",
    opacity: 0.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 50,
    textAnchor: "middle",
    fill: "#e2e8f0",
    fontFamily: "Arial, sans-serif",
    fontSize: 18,
    fontWeight: "bold"
  }, "A2A Example: Research + Writing Collaboration")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(180, 180)",
    filter: "url(#a2aExShadow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 55,
    fill: "none",
    stroke: "#8b5cf6",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "55;70",
    dur: "2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.5;0",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 50,
    fill: "url(#researchGrad)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "50;53;50",
    dur: "2.5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: -5,
    cy: -5,
    r: 12,
    fill: "none",
    stroke: "white",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 4,
    x2: 15,
    y2: 15,
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 75,
    textAnchor: "middle",
    fill: "#c4b5fd",
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold",
    fontSize: 13
  }, "Research Agent"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 105)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -55,
    y: -18,
    width: 110,
    height: 36,
    rx: 6,
    fill: "#0e7490",
    stroke: "#06b6d4",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    values: "0.5;1;0.5",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: -2,
    textAnchor: "middle",
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontSize: 9
  }, "Agent Card"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 10,
    textAnchor: "middle",
    fill: "#a5f3fc",
    fontFamily: "Arial, sans-serif",
    fontSize: 8
  }, "search, analyze, summarize")))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(620, 180)",
    filter: "url(#a2aExShadow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 55,
    fill: "none",
    stroke: "#ec4899",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "55;70",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "0.5s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.5;0",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "0.5s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 50,
    fill: "url(#writerGrad)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "50;53;50",
    dur: "2.5s",
    repeatCount: "indefinite",
    begin: "0.5s"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-10,15 L10,-10 L15,-5 L-5,20 Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8,18 L-12,22 L-5,20 Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 75,
    textAnchor: "middle",
    fill: "#f9a8d4",
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold",
    fontSize: 13
  }, "Writing Agent"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 105)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -55,
    y: -18,
    width: 110,
    height: 36,
    rx: 6,
    fill: "#0e7490",
    stroke: "#06b6d4",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    values: "0.5;1;0.5",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "0.5s"
  })), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: -2,
    textAnchor: "middle",
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontSize: 9
  }, "Agent Card"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 10,
    textAnchor: "middle",
    fill: "#a5f3fc",
    fontFamily: "Arial, sans-serif",
    fontSize: 8
  }, "write, edit, format")))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(400, 180)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -150,
    y: -30,
    width: 300,
    height: 60,
    rx: 30,
    fill: "#1e293b",
    stroke: "#475569",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -120,
    y: -18,
    width: 100,
    height: 36,
    rx: 8,
    fill: "#8b5cf6",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0.9;0.9;0",
    dur: "4s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "x",
    values: "-120;20",
    dur: "4s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontSize: 9,
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;1;0",
    dur: "4s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "x",
    values: "-70;70",
    dur: "4s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    values: "5;5",
    dur: "4s",
    repeatCount: "indefinite"
  }), "\n        Here's the data\n      ")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: -18,
    width: 100,
    height: 36,
    rx: 8,
    fill: "#ec4899",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0;0.9;0.9;0",
    dur: "4s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "x",
    values: "20;-120",
    dur: "4s",
    repeatCount: "indefinite",
    begin: "2s"
  })), /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontSize: 9,
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0;1;1;0",
    dur: "4s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "x",
    values: "70;-70",
    dur: "4s",
    repeatCount: "indefinite",
    begin: "2s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    values: "5;5",
    dur: "4s",
    repeatCount: "indefinite"
  }), "\n        Need more info\n      ")), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 55,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontFamily: "Arial, sans-serif",
    fontSize: 11
  }, "A2A Protocol - Bidirectional"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(400, 320)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -300,
    y: -15,
    width: 600,
    height: 30,
    rx: 15,
    fill: "#1e293b",
    stroke: "#475569",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -220,
    cy: 0,
    r: 8,
    fill: "#8b5cf6"
  }), /*#__PURE__*/React.createElement("text", {
    x: -200,
    y: 4,
    fill: "#94a3b8",
    fontFamily: "Arial, sans-serif",
    fontSize: 9
  }, "Discover"), /*#__PURE__*/React.createElement("line", {
    x1: -155,
    y1: 0,
    x2: -120,
    y2: 0,
    stroke: "#475569",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -100,
    cy: 0,
    r: 8,
    fill: "#06b6d4"
  }), /*#__PURE__*/React.createElement("text", {
    x: -80,
    y: 4,
    fill: "#94a3b8",
    fontFamily: "Arial, sans-serif",
    fontSize: 9
  }, "Connect"), /*#__PURE__*/React.createElement("line", {
    x1: -35,
    y1: 0,
    x2: 0,
    y2: 0,
    stroke: "#475569",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 0,
    r: 8,
    fill: "#22c55e"
  }), /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 4,
    fill: "#94a3b8",
    fontFamily: "Arial, sans-serif",
    fontSize: 9
  }, "Collaborate"), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 0,
    x2: 135,
    y2: 0,
    stroke: "#475569",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 155,
    cy: 0,
    r: 8,
    fill: "#f59e0b"
  }), /*#__PURE__*/React.createElement("text", {
    x: 175,
    y: 4,
    fill: "#94a3b8",
    fontFamily: "Arial, sans-serif",
    fontSize: 9
  }, "Iterate"), /*#__PURE__*/React.createElement("line", {
    x1: 210,
    y1: 0,
    x2: 245,
    y2: 0,
    stroke: "#475569",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265,
    cy: 0,
    r: 8,
    fill: "#ec4899"
  }), /*#__PURE__*/React.createElement("text", {
    x: 285,
    y: 4,
    fill: "#94a3b8",
    fontFamily: "Arial, sans-serif",
    fontSize: 9
  }, "Done"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgA2AExample);
export default __webpack_public_path__ + "static/media/a2a-example.c7c0810e1948c6e24e458fbe83d082ab.svg";
export { ForwardRef as ReactComponent };